import React from 'react';
export { default as SignIn } from './LoginForm/signIn/signIn.js';
export { default as ForgotPsswd } from './LoginForm/forgotPsswd/forgotPsswd.js';
export { default as ChangePsswd } from './LoginForm/changePsswd/changePsswd.js';
export { default as TwoFactorAuth } from './LoginForm/twoFactorAuth/twoFactorAuth.js';
export { default as Home } from './HomeNew/home.js';
export { default as User } from './User/User.js';